module.exports = "/images/vendor/flag-icon-css/flags/4x3/mw.svg?6073ddcffcc7c715883b34f702bef924";